// extracted by mini-css-extract-plugin
module.exports = {"user":"HeaderUserIcon_user__3fAcZ","userMenu":"HeaderUserIcon_userMenu__24GVJ","userMenuContent":"HeaderUserIcon_userMenuContent__bEDw3","overlay":"HeaderUserIcon_overlay__2-506"};